import styled, { css } from 'styled-components';

export const Gallery = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  margin: 0px auto;
  padding: 0 20px;
`;

export const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background: ${backgroundColor};
    `}
`;
